module.exports = "<i ng-class=\"icon.classList\"></i>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/icon/directives/icon/templates/icon.html
// module id = 913
// module chunks = 0